import {get} from '@servicenow/ui-internal';

/**
 * Utility function to get resolved value with a path
 * @param resolvedValue
 * @param path
 * @returns {*}
 */
export default function getResolvedValue(resolvedValue, path) {
	if (resolvedValue && path) return get(resolvedValue, path);

	return resolvedValue;
}
